import { ScreenWithFooter } from "@atomic"
import { NavigationProp } from "@react-navigation/native"
import { GlobalState } from "@redux"
import { Title22, Title30 } from "@stylesheets"
import React from "react"
import { View, ScrollView, Pressable } from "react-native"
import { useSelector } from "react-redux"
import { I18n } from "react-redux-i18n"
import { useDevices } from "@hooks"
import { Images } from "@assets"
import { CloseIcon } from "@assets/icons/CloseIcon";
import { badgeTemplateStyles } from "./styles"

interface IProps {
  children?: React.ReactNode
  navigation: NavigationProp<any>
}

export const BadgeAssociationTemplate = React.forwardRef<ScrollView, IProps>(
  ({ children, navigation }, ref) => {
    const [isMobile] = useDevices()

    const Title: React.FC<any> = isMobile ? Title22 : Title30

    const { selectedHolding, successfullyAddedHolding } = useSelector(
      (state: GlobalState) => state.account
    )
    const styles = badgeTemplateStyles(isMobile, successfullyAddedHolding)

    const onBackPress = () => {
      navigation?.goBack();
    }

    return (
      <ScreenWithFooter ref={ref} navigation={navigation}>
        <View style={styles.container}>
          <View style={styles.backGroundImage}>
            <Images.CGUBackground />
          </View>
          <View style={styles.stepsContainer}>
            {successfullyAddedHolding ? null : (
              <View style={styles.titleContainer}>
                <Title isBlack style={styles.title}>
                  {!selectedHolding
                    ? I18n.t("associationBadge.bigStepsTitles.0")
                    : I18n.t("associationBadge.bigStepsTitles.1")}
                </Title>
                <Pressable
                  style={styles.backButtonContainer}
                  onPress={onBackPress}
                >
                  <CloseIcon size={20}/>
                </Pressable>
              </View>
            )}
            {children}
          </View>
        </View>
      </ScreenWithFooter>
    )
  }
)
